import OneColumnWrapper from './OneColumnWrapper';

export default OneColumnWrapper;
